import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const AttendancesContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.attendantsWithMoreAttendances?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            labels.push(ReportUtils.formatText(item.namewar));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Atendimentos por atendente");
        GraphicUtils.barChart('attendants-with-more-attendances', values.slice(0, 10), labels.slice(0, 10), false);
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <div className="chart-title mb-3">Atendimentos por atendente {data.attendantsWithMoreAttendances.length >= 10 ? ' (TOP 10)' : ''}</div>
                <div className="chart-report bar-chart" id="attendants-with-more-attendances"></div>
            </div>
        </>
    );
};

export default AttendancesContent;